
import React from 'react';

const Thrash = (props: { className: string, onClick?: any }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (

        <svg className={className} onClick={handleOnClick} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g id="thrash">
            <path id="Vector" d="M13.0001 3.11755H1"  stroke-width="1.5" stroke-linecap="round"/>
            <path id="Vector_2" d="M11.8238 4.88245L11.4991 9.36281C11.3742 11.0869 11.3117 11.949 10.7011 12.4745C10.0905 13.0001 9.15142 13.0001 7.27321 13.0001H6.72731C4.84909 13.0001 3.90999 13.0001 3.29939 12.4745C2.6888 11.949 2.62633 11.0869 2.50139 9.36281L2.17673 4.88245"  stroke-width="1.5" stroke-linecap="round"/>
            <path id="Vector_3" d="M3.11765 3.11765C3.15709 3.11765 3.17681 3.11765 3.19469 3.11719C3.77595 3.10246 4.28872 2.73288 4.4865 2.18611C4.49259 2.16929 4.49882 2.15058 4.5113 2.11316L4.57983 1.90756C4.63833 1.73206 4.66759 1.6443 4.70638 1.56979C4.86118 1.27252 5.14758 1.0661 5.47855 1.01325C5.5615 1 5.654 1 5.83901 1H8.16099C8.34599 1 8.4385 1 8.52145 1.01325C8.85241 1.0661 9.13881 1.27252 9.29361 1.56979C9.33241 1.6443 9.36166 1.73205 9.42017 1.90756L9.4887 2.11316C9.50116 2.15053 9.50741 2.1693 9.51349 2.18611C9.71128 2.73288 10.2241 3.10246 10.8053 3.11719C10.8232 3.11765 10.8429 3.11765 10.8824 3.11765"  stroke-width="1.5"/>
            </g>
        </svg>
  );
};
export default Thrash;


